<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div mat-dialog-title>
  <div style="font-size: 20px;">
    <div style="flex:25%">
      <mat-form-field class="example-full-width">
        <mat-label>Control ID</mat-label>
        <input matInput  name="complianceAreaControlId"
               [(ngModel)]="controlItem.complianceAreaControlId">
      </mat-form-field>
    </div>
    <div style="flex:2%"></div>
    <div style="flex:50%">
      <mat-form-field class="example-full-width" style="width: 100%">
        <mat-label>Short Name</mat-label>
        <input matInput [(ngModel)]="controlItem.shortName"  />
      </mat-form-field>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="control-item-component" style="display: flex; flex-direction: column;">
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
         >

      <div style="flex:49%">
        <mat-form-field class="example-full-width">
          <mat-label>Compliance area</mat-label>
          <mat-select  [(ngModel)]="controlItem.complianceAreaId"
                      name="complianceArea" (change)="onAreaChange()">
            <mat-option *ngFor="let complianceArea of complianceAreas" [value]="complianceArea.complianceAreaId">
              {{complianceArea.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!--form class="example-form">
          <mat-form-field class="example-full-width">
            <mat-label>Control Item Type</mat-label>
              <input matInput  name="controlItemType" [(ngModel)]="controlItem.controlItemType" >
          </mat-form-field>
      </form-->

      <div style="flex:2%"></div>


      <div style="flex:45%">
        <mat-form-field class="description-form">
          <mat-label>Category</mat-label>
                            <textarea matInput
                                      cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                      cdkAutosizeMinRows="1"
                                      cdkAutosizeMaxRows="1"
                                      type="text"

                                      class="form-control"
                                      name="category"
                                      rows="10"
                                      cols="80"
                                      [(ngModel)]="controlItem.category"
                                      #description="ngModel">
                            </textarea>
        </mat-form-field>
      </div>
      <div style="flex:2%"></div>
      <div style="flex:25%">
        <mat-form-field class="example-full-width">
          <mat-label>Level</mat-label>
          <input matInput

                 name="level"
                 [(ngModel)]="controlItem.level">

        </mat-form-field>
      </div>
      <div style="flex:2%"></div>
      <div style="flex:25%">
        <mat-form-field class="example-full-width">
          <mat-label>Priority</mat-label>
          <input matInput

                 name="priority"
                 [(ngModel)]="controlItem.priority">

        </mat-form-field>
      </div>
      <div style="flex:2%"></div>
      <div style="flex:25%">
        <mat-form-field class="example-full-width">
          <mat-label>Value</mat-label>
          <input matInput
                 type="number"

                 name="value"
                 [(ngModel)]="controlItem.value">

        </mat-form-field>
      </div>

    </div>

    <div>
      <div class="form-group">
        <mat-label style="color: rgba(0,0,0,.54)">Scoring Guidance<span class="pi pi-pencil"
                                                                        (click)="visibility.scoringGuidanceEdit = !visibility.scoringGuidanceEdit"></span>
        </mat-label>
        <div class="ql-editor" *ngIf="!visibility.scoringGuidanceEdit"
             [innerHTML]="addToken(controlItem.scoringGuidance) | sanitizeHtml"></div>
        <p-editor matInput
                  *ngIf="visibility.scoringGuidanceEdit"
                  type="text"
                  name="references"
                  [(ngModel)]="controlItem.scoringGuidance"
                  #description="ngModel">
          <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
            <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
            <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
            <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
            <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
            <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
          </p-header>
        </p-editor>
      </div>

    </div>

    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
         >
      <mat-form-field class="description-form">
        <mat-label>Description</mat-label>
                        <textarea matInput
                                  cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10"
                                  type="text"

                                  class="form-control"
                                  name="description"
                                  rows="10"
                                  cols="80"
                                  [(ngModel)]="controlItem.description"
                                  #description="ngModel">
                        </textarea>
      </mat-form-field>
    </div>

    <div style="display: flex; flex-direction: row;">
      <div style="flex:25%" *ngIf="controlItem.parentControlItemId && parent">
        <mat-form-field class="example-full-width">
          <mat-label>Practice</mat-label>
          <input matInput

                 name="practice"
                 [(ngModel)]="controlItem.complianceAreaControlId">

        </mat-form-field>
      </div>
      <div style="flex:25%" *ngIf="controlItem.parentControlItemId && parent">
        <mat-form-field class="example-full-width">
          <mat-label>Label</mat-label>
          <input matInput

                 name="label"
                 [(ngModel)]="controlItem.label">

        </mat-form-field>
      </div>
    </div>
    <div style="display: flex; flex-direction: row;">
      <div style="flex:100%" *ngIf="controlItem.parentControlItemId && parent">
        <label style="color: rgba(0,0,0,.54)">Rizkly Advisor Guidance <span class="pi pi-pencil"
                                                                            (click)="visibility.practiceGuidanceEdit = !visibility.practiceGuidanceEdit"></span></label>
        <div class="ql-editor" *ngIf="!visibility.practiceGuidanceEdit"
             [innerHTML]="addToken(controlItem.practiceGuidance)  | sanitizeHtml"></div>
        <p-editor matInput
                  *ngIf="visibility.practiceGuidanceEdit"
                  type="text"
                  name="references"
                  [(ngModel)]="controlItem.practiceGuidance"
                  #description="ngModel">
          <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
            <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
            <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
            <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
            <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
            <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
          </p-header>
        </p-editor>

      </div>
    </div>
    <div style="display: flex; flex-direction: row;">
      <div style="flex:25%">
        <mat-checkbox class="example-margin"
                      [(ngModel)]="controlItem.isLow"
                      name="Low">Low
        </mat-checkbox>
      </div>
      <div style="flex:25%">
        <mat-checkbox class="example-margin"
                      [(ngModel)]="controlItem.isMedium"
                      name="Medium">Medium
        </mat-checkbox>
      </div>
      <div style="flex:25%">
        <mat-checkbox class="example-margin"
                      [(ngModel)]="controlItem.isHigh"
                      name="High">High
        </mat-checkbox>
      </div>
      <div style="flex:25%">
        <mat-form-field>
          <mat-label></mat-label>
          <mat-select placeholder="Type"
                      [(ngModel)]="controlType"
                      (selectionChange)="controlItem.type = $event.value"
          >
            <mat-select-trigger style="display: inline-block;">
              <input
                [(ngModel)]="controlItem.type"

                (click)="$event.stopPropagation()"
              >
            </mat-select-trigger>
            <mat-option [value]="'Unexisting'" style="display:none"></mat-option>
            <mat-option [value]="'Common'">Common</mat-option>
            <mat-option [value]="'Hybrid'">Hybrid</mat-option>
            <mat-option [value]="'Specific'">Specific</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="flex:25%">
        <mat-form-field>
          <mat-label>Frequency</mat-label>
          <mat-select
            [(ngModel)]="controlItem.frequency">
            <mat-option *ngFor="let rec of recurringList" [value]="rec.value">
              {{rec.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="tenantPermissions && tenantPermissions.isWorkstreamsEnabled && controlItem.workstreamItem">
      <div class="splitter">Workstream</div>
      <div style="display: flex; flex-direction: row;">
        <div style="flex:50%">
          <mat-form-field style="width: 100%">
            <mat-label>Workstream</mat-label>
            <input matInput

                   [(ngModel)]="controlItem.workstreamItem.workstreamName"
                   disabled
            >
          </mat-form-field>
        </div>
        <div style="flex:50%">
          <mat-form-field style="width: 100%">
            <mat-label>WS Item Name</mat-label>
            <input matInput

                   [(ngModel)]="controlItem.workstreamItem.wsid"
                   disabled
            >
          </mat-form-field>
        </div>
      </div>
      <div style="display: flex; flex-direction: row;">
        <mat-form-field style="width: 100%">
          <mat-label>WS Item Name</mat-label>
          <textarea matInput
                    cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="4"

                    [(ngModel)]="controlItem.workstreamItem.keyCriteria"
                    disabled
          ></textarea>
        </mat-form-field>
      </div>
    </div>

    <div>
      <div class="splitter">Policy and Procedures</div>

      <p-table [value]="selectedPolicies"

               dataKey="id">
        <ng-template pTemplate="body" let-item let-expanded="expanded">
          <tr [pRowToggler]="item">
            <td style="width:2em;">
                    <span>
                      <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                    </span>
            </td>
            <td>{{item.name}}</td>
            <td style="width: 5em;">
              <span class="pi pi-trash" (click)="removePolicy(item)"></span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="expandedrow" let-item>
          <tr>
            <td colspan="3">
              <span class="ql-editor" [innerHTML]="addToken(item.text) | sanitizeHtml"></span>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div>
        <div class="fa fa-plus" (click)="addPolicy()"></div>
      </div>
    </div>

    <div class="splitter">Assessment Information</div>


    <fieldset *ngIf="isNotHiddenForComplianceArea">
      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
           >

        <div style="flex:49%">
          <mat-checkbox class="example-margin"
                        [(ngModel)]="controlItem.fP199Low"
                        name="fP199Low">FP199 Low
          </mat-checkbox>
        </div>

        <div style="flex:49%">
          <mat-checkbox class="example-margin"
                        [(ngModel)]="controlItem.fP199Moderate"
                        name="fP199Moderate">FP199 Moderate
          </mat-checkbox>
        </div>

        <div style="flex:49%">
          <mat-checkbox class="example-margin"
                        [(ngModel)]="controlItem.fP199High"
                        name="fP199High">FP199 High
          </mat-checkbox>
        </div>
      </div>
    </fieldset>

    <fieldset *ngIf="isNotHiddenForComplianceArea">
      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
           >
        <div style="flex:49%">
          <mat-checkbox class="example-margin"
                        [(ngModel)]="controlItem.fedRAMPLow"
                        name="fedRAMPLow">FedRAMP Low
          </mat-checkbox>
        </div>

        <div style="flex:49%">
          <mat-checkbox class="example-margin"
                        [(ngModel)]="controlItem.fedRAMPModerate"
                        name="fedRAMPModerate">FedRAMP Moderate
          </mat-checkbox>
        </div>

        <div style="flex:49%"></div>
      </div>

      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
           >

        <div style="display: flex; flex-direction: column; flex:49%">
          <mat-form-field class="description-form">
            <mat-label>Fed RAMP Continuous Monitoring Template</mat-label>
                                <textarea matInput
                                          cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="4"
                                          type="text"

                                          class="form-control"
                                          name="fedRAMPContinuousMonitoringTemplate"
                                          cols="60"
                                          [(ngModel)]="controlItem.fedRAMPContinuousMonitoringTemplate"
                                          #description="ngModel">
                                </textarea>
          </mat-form-field>
        </div>

        <div style="flex:2%; display: flex; flex-direction: column;"></div>

        <div style="flex:49%">
          <mat-form-field class="description-form">
            <mat-label>FedRAMP Annual Assessment Guidance</mat-label>
                                <textarea matInput
                                          cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="4"
                                          type="text"

                                          class="form-control"
                                          name="fedRAMPAnnualAssessmentGuidance"
                                          cols="60"
                                          [(ngModel)]="controlItem.fedRAMPAnnualAssessmentGuidance"
                                          #description="ngModel">
                                </textarea>
          </mat-form-field>
        </div>
      </div>
    </fieldset>

    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
         >

      <div style="flex:49%" *ngIf="isNotHiddenForComplianceArea">
        <mat-form-field class="description-form">
          <mat-label>Organizational Parameters</mat-label>
                            <textarea matInput
                                      cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                      cdkAutosizeMinRows="1"
                                      cdkAutosizeMaxRows="4"
                                      type="text"

                                      class="form-control"
                                      name="organizationalParameters"
                                      cols="60"
                                      [(ngModel)]="controlItem.organizationalParameters"
                                      #description="ngModel">
                            </textarea>
        </mat-form-field>
      </div>

      <div style="flex:2%" *ngIf="isNotHiddenForComplianceArea"></div>

      <div style="flex:49%">
        <mat-form-field class="description-form">
          <mat-label>Related Controls</mat-label>
                            <textarea matInput
                                      cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                      cdkAutosizeMinRows="1"
                                      cdkAutosizeMaxRows="4"
                                      type="text"

                                      class="form-control"
                                      name="relatedControls"
                                      cols="60"
                                      [(ngModel)]="controlItem.relatedControls"
                                      #description="ngModel">
                            </textarea>
        </mat-form-field>
      </div>
    </div>

    <fieldset *ngIf="isNotHiddenForComplianceArea">
      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
           >

        <div style="flex:49%">
          <mat-form-field class="description-form">
            <mat-label>Privacy Act</mat-label>
                                <textarea matInput
                                          cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="10"
                                          type="text"

                                          class="form-control"
                                          name="privacyAct"
                                          rows="10"
                                          cols="80"
                                          [(ngModel)]="controlItem.privacyAct"
                                          #description="ngModel">
                                </textarea>
          </mat-form-field>
        </div>

        <div style="flex:2%"></div>

        <div style="flex:49%">
          <mat-form-field class="description-form">
            <mat-label>HIPAA</mat-label>
                                <textarea matInput
                                          cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="10"
                                          type="text"

                                          class="form-control"
                                          name="hIPAA"
                                          rows="10"
                                          cols="80"
                                          [(ngModel)]="controlItem.hipaa"
                                          #description="ngModel">
                                </textarea>
          </mat-form-field>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
           >

        <div style="flex:49%">
          <mat-form-field class="description-form">
            <mat-label>OMB / EO / HSPD</mat-label>
                                <textarea matInput
                                          cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="10"
                                          type="text"

                                          class="form-control"
                                          name="oMB_EO_HSPD"
                                          rows="10"
                                          cols="80"
                                          [(ngModel)]="controlItem.omB_EO_HSPD"
                                          #description="ngModel">
                                </textarea>
          </mat-form-field>
        </div>

        <div style="flex:2%"></div>

        <div style="flex:49%">
          <mat-form-field class="description-form">
            <mat-label>FISCAM</mat-label>
                                <textarea matInput
                                          cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="10"
                                          type="text"

                                          class="form-control"
                                          name="fISCAM"
                                          rows="10"
                                          cols="80"
                                          [(ngModel)]="controlItem.fiscam"
                                          #description="ngModel">
                                </textarea>
          </mat-form-field>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
           >

        <div style="flex:49%">
          <mat-form-field class="description-form">
            <mat-label>NISTIR7966</mat-label>
                                <textarea matInput
                                          cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="10"
                                          type="text"

                                          class="form-control"
                                          name="nISTIR7966"
                                          rows="10"
                                          cols="80"
                                          [(ngModel)]="controlItem.nistiR7966"
                                          #description="ngModel">
                                </textarea>
          </mat-form-field>
        </div>

        <div style="flex:2%"></div>

        <div style="flex:49%">
          <mat-form-field class="description-form">
            <mat-label>Draft 800-171 Rev1</mat-label>
                                <textarea matInput
                                          cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="10"
                                          type="text"

                                          class="form-control"
                                          name="draft800_171Rev1"
                                          rows="10"
                                          cols="80"
                                          [(ngModel)]="controlItem.draft800_171Rev1"
                                          #description="ngModel">
                                </textarea>
          </mat-form-field>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
           >

        <div style="flex:49%">
          <mat-form-field class="description-form">
            <mat-label>FedRAMP</mat-label>
                                <textarea matInput
                                          cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="10"
                                          type="text"

                                          class="form-control"
                                          name="fedRAMP"
                                          rows="10"
                                          cols="80"
                                          [(ngModel)]="controlItem.fedRAMP"
                                          #description="ngModel">
                                </textarea>
          </mat-form-field>
        </div>

        <div style="flex:2%"></div>

        <div style="flex:49%">
          <label style="color: rgba(0,0,0,.54)">References <span class="pi pi-pencil"
                                                                 (click)="visibility.referencesEdit = !visibility.referencesEdit"></span></label>
          <div class="ql-editor" *ngIf="!visibility.referencesEdit"
               [innerHTML]="addToken(controlItem.instructions) | sanitizeHtml"></div>
          <p-editor matInput
                    *ngIf="visibility.referencesEdit"
                    type="text"
                    name="references"
                    [(ngModel)]="controlItem.references"
                    #description="ngModel">
            <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
              <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
              <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
              <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
              <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
              <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
            </p-header>
          </p-editor>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
           >

        <div style="flex:49%">
          <mat-form-field class="description-form">
            <mat-label>ISO 27001</mat-label>
                                <textarea matInput
                                          cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="10"
                                          type="text"

                                          class="form-control"
                                          name="iSO27001"
                                          rows="10"
                                          cols="80"
                                          [(ngModel)]="controlItem.isO27001"
                                          #description="ngModel">
                                </textarea>
          </mat-form-field>
        </div>
      </div>
    </fieldset>

    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
          *ngIf="isNotHiddenForComplianceArea">
      <mat-form-field class="description-form">
        <mat-label>Assessment Objective</mat-label>
                        <textarea matInput
                                  cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10"
                                  type="text"

                                  class="form-control"
                                  name="assessmentObjective"
                                  rows="10"
                                  cols="80"
                                  [(ngModel)]="controlItem.assessmentObjective"
                                  #description="ngModel">
                        </textarea>
      </mat-form-field>
    </div>

    <div style="display: flex; flex-direction: column; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
          *ngIf="isNotHiddenForComplianceArea">

      <mat-label style="color: rgba(0,0,0,.54)">Potential Assessment Methods and Objects <span class="pi pi-pencil"
                                                                                               (click)="visibility.potentialAssessmentMethodsandObjectsEdit = !visibility.potentialAssessmentMethodsandObjectsEdit"></span>
      </mat-label>
      <div class="ql-editor" *ngIf="!visibility.potentialAssessmentMethodsandObjectsEdit"
           [innerHTML]="addToken(controlItem.potentialAssessmentMethodsandObjects) | sanitizeHtml"></div>
      <p-editor matInput
                *ngIf="visibility.potentialAssessmentMethodsandObjectsEdit"
                type="text"
                name="references"
                [(ngModel)]="controlItem.potentialAssessmentMethodsandObjects"
                #description="ngModel">
        <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
          <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
          <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
          <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
        </p-header>
      </p-editor>

    </div>

    <div class="form-group">
      <mat-label style="color: rgba(0,0,0,.54)">Instructions <span class="pi pi-pencil"
                                                                   (click)="visibility.instructionsEdit = !visibility.instructionsEdit"></span>
      </mat-label>
      <div class="ql-editor" *ngIf="!visibility.instructionsEdit"
           [innerHTML]="addToken(controlItem.instructions) | sanitizeHtml"></div>
      <p-editor matInput
                *ngIf="visibility.instructionsEdit"
                type="text"
                name="instructions"
                [(ngModel)]="controlItem.instructions"
                #description="ngModel">
        <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
          <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
          <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
          <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
        </p-header>
      </p-editor>

    </div>

    <div class="form-group">
      <mat-label style="color: rgba(0,0,0,.54)">Evidence Instructions <span class="pi pi-pencil"
                                                                            (click)="visibility.evidenceInstructionsEdit = !visibility.evidenceInstructionsEdit"></span>
      </mat-label>
      <div class="ql-editor" *ngIf="!visibility.evidenceInstructionsEdit"
           [innerHTML]="addToken(controlItem.evidenceInstructions) | sanitizeHtml"></div>
      <p-editor matInput
                *ngIf="visibility.evidenceInstructionsEdit"
                type="text"
                name="evidenceInstructions"
                [(ngModel)]="controlItem.evidenceInstructions"
                #description="ngModel">
        <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
          <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
          <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
          <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
        </p-header>
      </p-editor>

    </div>

    <div class="form-group">
      <mat-label style="color: rgba(0,0,0,.54)">Documentation Instructions <span class="pi pi-pencil"
                                                                                 (click)="visibility.documentationInstructionsEdit = !visibility.documentationInstructionsEdit"></span>
      </mat-label>
      <div class="ql-editor" *ngIf="!visibility.documentationInstructionsEdit"
           [innerHTML]="addToken(controlItem.documentationInstructions) | sanitizeHtml"></div>
      <p-editor matInput
                *ngIf="visibility.documentationInstructionsEdit"
                type="text"
                name="documentationInstructions"
                [(ngModel)]="controlItem.documentationInstructions"
                #description="ngModel">
        <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
          <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
          <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
          <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
        </p-header>
      </p-editor>

    </div>

    <div class="form-group" style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
         >
      <mat-form-field class="description-form">
        <mat-label>Official Guidance</mat-label>
                        <textarea matInput
                                  cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10"
                                  type="text"

                                  class="form-control"
                                  name="supplementalGuidance"
                                  rows="10"
                                  cols="80"
                                  [(ngModel)]="controlItem.supplementalGuidance"
                                  #description="ngModel">
                        </textarea>
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-label style="color: rgba(0,0,0,.54)">Clarification Summary <span class="pi pi-pencil"
                                                                            (click)="visibility.clarificationSummaryEdit = !visibility.clarificationSummaryEdit"></span>
      </mat-label>
      <div class="ql-editor" *ngIf="!visibility.clarificationSummaryEdit"
           [innerHTML]="addToken(controlItem.clarificationSummary) | sanitizeHtml"></div>
      <p-editor matInput
                *ngIf="visibility.clarificationSummaryEdit"
                type="text"
                name="references"
                [(ngModel)]="controlItem.clarificationSummary"
                #description="ngModel">
        <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
          <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
          <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
          <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
        </p-header>
      </p-editor>
    </div>

    <div class="form-group">
      <mat-label style="color: rgba(0,0,0,.54)">Example <span class="pi pi-pencil"
                                                              (click)="visibility.exampleEdit = !visibility.exampleEdit"></span>
      </mat-label>
      <div class="ql-editor" *ngIf="!visibility.exampleEdit"
           [innerHTML]="addToken(controlItem.example) | sanitizeHtml"></div>
      <p-editor matInput
                *ngIf="visibility.exampleEdit"
                type="text"
                name="references"
                [(ngModel)]="controlItem.example"
                #description="ngModel">
        <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
          <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
          <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
          <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
        </p-header>
      </p-editor>
    </div>


    <div class="form-group">
      <div style="flex:100%">
        <mat-form-field class="description-form">
          <mat-label>Policy</mat-label>
                      <textarea matInput
                                cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2"
                                cdkAutosizeMaxRows="10"
                                type="text"
                                class="form-control"


                                rows="10"


                                [(ngModel)]="controlItem.customDescription"
                                name="customDescription"
                                #clientInstructions="ngModel">
                        </textarea>
        </mat-form-field>
      </div>

    </div>


    <div class="form-group">
      <mat-label style="color: rgba(0,0,0,.54)">Advisor Standing Instructions <span class="pi pi-pencil"
                                                                                    (click)="visibility.consultantInstructionsEdit = !visibility.consultantInstructionsEdit"></span>
      </mat-label>
      <div class="ql-editor" *ngIf="!visibility.consultantInstructionsEdit"
           [innerHTML]="addToken(controlItem.consultantInstructions) | sanitizeHtml"></div>
      <p-editor matInput
                *ngIf="visibility.consultantInstructionsEdit"
                type="text"
                name="references"
                [(ngModel)]="controlItem.consultantInstructions"
                #description="ngModel">
        <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
          <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
          <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
          <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
        </p-header>
      </p-editor>
    </div>

    <div class="form-group">
      <mat-form-field class="description-form">
        <mat-label>Client Standing Instructions</mat-label>
                        <textarea matInput
                                  cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="2"
                                  cdkAutosizeMaxRows="10"
                                  type="text"
                                  class="form-control"

                                  name="clientInstructions"
                                  rows="10"
                                  [(ngModel)]="controlItem.clientInstructions"
                                  #clientInstructions="ngModel">
                        </textarea>
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field class="description-form">
        <mat-label>Additional Requirements</mat-label>
                        <textarea matInput
                                  cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="2"
                                  cdkAutosizeMaxRows="10"
                                  type="text"
                                  class="form-control"

                                  name="additionalRequirements"
                                  rows="10"
                                  [(ngModel)]="controlItem.additionalRequirements"
                                  #clientInstructions="ngModel">
                        </textarea>
      </mat-form-field>
    </div>

    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"

         *ngIf="isNotHiddenForComplianceArea">

      <div style="flex:49%">
        <mat-form-field class="example-full-width">
          <mat-label>FedRAMP Risk Exposure</mat-label>
          <mat-select
                      [(ngModel)]="controlItem.fedRAMPRiskExposure"
                      name="fedRAMPRiskExposure">
            <mat-option [value]="0">None</mat-option>
            <mat-option [value]="1">Low</mat-option>
            <mat-option [value]="2">Medium</mat-option>
            <mat-option [value]="3">High</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="form-group" *ngIf="isNotHiddenForComplianceArea">
      <mat-form-field class="description-form">
        <mat-label>Organizational Parameters</mat-label>
                        <textarea matInput
                                  cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="2"
                                  cdkAutosizeMaxRows="10"
                                  type="text"
                                  class="form-control"

                                  name="organizationalParameters"
                                  rows="10"
                                  [(ngModel)]="controlItem.organizationalParameters"
                                  #clientInstructions="ngModel">
                        </textarea>
      </mat-form-field>
    </div>

    <div class="form-group" *ngIf="isNotHiddenForComplianceArea">
      <mat-form-field class="description-form">
        <mat-label>Control Origination</mat-label>
                        <textarea matInput
                                  cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="2"
                                  cdkAutosizeMaxRows="10"
                                  type="text"
                                  class="form-control"

                                  name="controlOrigination"
                                  rows="10"
                                  [(ngModel)]="controlItem.controlOrigination"
                                  #clientInstructions="ngModel">
                        </textarea>
      </mat-form-field>
    </div>


    <div>

      <span class="fa fa-plus" (click)="addSubItem()"></span>

      <p-table *ngIf="rowGroupMetadata"
               [value]="controlItem.subItems"
               dataKey="level"
               #table
               [expandedRowKeys]="expanded"
      >

        <ng-template pTemplate="header">
          <tr style="white-space: nowrap;font-weight: bold">
            <th *ngFor="let col of cols" [pSortableColumn]="col.field">
              {{col.header}}
            </th>
            <th style="width:15em"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr class="ui-widget-header" *ngIf="rowGroupMetadata[item.level].index === rowIndex">
            <td colspan="4">
              <a href="#" [pRowToggler]="item">
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                <span>{{item.level}}</span>
              </a>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="expandedrow" let-item>
          <tr [pSelectableRow]="item">
            <td>{{item.complianceArea.name}}</td>
            <td>{{item.complianceAreaControlId}}</td>
            <td>{{item.label}}</td>
            <td>{{item.category}}</td>
            <td>{{item.description}}</td>
            <td>
              <button
                type="button"
                pButton
                class="risksponge-button"
                (click)="edit(item)"
                icon="pi pi-pencil"
              ></button>
              <button
                type="button"
                pButton
                class="risksponge-button"
                (click)="removeSubItem(item)"
                icon="pi pi-trash">
              </button>
              <button
                type="button"
                pButton
                class="risksponge-button"
                (click)="moveDown(item)"
                *ngIf="item.level != defaultGroups[0]"
                icon="pi pi-arrow-up">
              </button>
              <button
                type="button"
                pButton
                class="risksponge-button"
                (click)="moveUp(item)"
                *ngIf="item.level != defaultGroups[defaultGroups.length - 1]"
                icon="pi pi-arrow-down">
              </button>
            </td>
          </tr>
        </ng-template>

      </p-table>

    </div>
    <div class="splitter">Reference Resources</div>
    <p-table
      *ngIf="controlItem"
      [value]="referenceResources"
      #table
    >

      <ng-template pTemplate="header">
        <tr style="white-space: nowrap;font-weight: bold">
          <th *ngFor="let col of referenceResourceCols" [pSortableColumn]="col.field"
              [ngStyle]="{'width': col.width || 'auto'}">
            {{col.header}}
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
          <td>
            <a
              *ngIf="item.url?.startsWith('http://') || item.url?.startsWith('https://') || item.url?.startsWith('\\\\')"
              [attr.href]="item.url" target="_blank" class="btn btn-link">{{item.name}}</a>
          </td>
          <td style="font-size: 0.75; word-break: break-all">
            {{item.sourceProvider}}
          </td>
          <td>
            <span>{{item.notes}}</span>
          </td>
        </tr>
      </ng-template>

    </p-table>

    <div class="splitter">Recommended Solutions</div>
    <p-table
      *ngIf="controlItem"
      [value]="recommendedSolutions"
      #table
    >

      <ng-template pTemplate="header">
        <tr style="white-space: nowrap;font-weight: bold">
          <th *ngFor="let col of recommendedSolutionCols" [pSortableColumn]="col.field"
              [ngStyle]="{'width': col.width || 'auto'}">
            {{col.header}}
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
          <td style="font-size: 0.75; word-break: break-all">
            <a
              *ngIf="item.url?.startsWith('http://') || item.url?.startsWith('https://') || item.url?.startsWith('\\\\')"
              [attr.href]="item.url" target="_blank" class="btn btn-link">{{item.name}}</a>
          </td>
          <td>
            <span>{{item.description}}</span>
          </td>
          <td>{{item.contact}}</td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button [disabled]="loading" (click)="onSave()" style="border-radius: 6px;">Save</button>
  <img *ngIf="loading"
       src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
  <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Cancel</button>
</div>
